export const languageList = [
    {
      text: '한국어',
      code: 'kr'
    },
    {
      text: 'English',
      code: 'en'
    },
    {
      text: '日本語',
      code: 'jp'
    },
    {
      text: '中国话',
      code: 'cn'
    },
    {
      text: 'español',
      code: 'es'
    },
    {
      text: 'français .',
      code: 'fr'
    },
    {
      text: 'Deutsche',
      code: 'de'
    },
    {
      text: 'Русский',
      code: 'py'
    }
  ]
